module.exports = __webpack_public_path__ + "static/calefaccion-a950bc15e26859a553260b3018b1c4a8.jpg";